<script setup lang="ts">
const appConfig = useAppConfig()
const { accessibleItems } = useSidebar()
const { locale, t } = useI18n()

const { fetchUser, user } = useDirectusAuth()

const switchLocalePath = useSwitchLocalePath()
// await fetchUser()

let isOpen = useState('collapse-open')
isOpen.value = true

watchEffect(() => {
  if (appConfig.tairo.collapse?.navigation) {
    appConfig.tairo.collapse.navigation.items = accessibleItems.value
  }
})

const isAdminOrOrganizer = computed(() => {
  return ['admin', 'super-administrator'].includes(
    user.value?.role,
  )
})


if (isAdminOrOrganizer.value) {
  console.log('Admin or Organizer');


  navigateTo(switchLocalePath('nl'))
}

useHead({
  script: computed(() => {
    if (!isAdminOrOrganizer.value) return []

    return [
      // {
      //   async: true,
      //   defer: true,
      //   src: '/js/marker.js',
      // },
    ]
  }),
})
</script>

<template>
  <div>
    <TairoCollapseLayout>
      <slot />
      <ModalWrapper />
    </TairoCollapseLayout>
  </div>
</template>
